// Maps icon name strings (stored in the database) to lucide-react components.
// Used as a visual fallback for category cards (Others / Offers / Festival)
// until a real photo/video is uploaded for that item via the Admin Portal.
import {
  Heart,
  Flower2,
  Link2,
  Sparkles,
  Baby,
  Wand2,
  RefreshCw,
  PartyPopper,
  ShieldCheck,
  Tag,
  Diamond,
  Gem,
  CircleDashed,
  Footprints,
  Gift,
  Star,
  Crown,
  Sun,
} from "lucide-react";

export const ICON_MAP = {
  Heart,
  Flower2,
  Link2,
  Sparkles,
  Baby,
  Wand2,
  RefreshCw,
  PartyPopper,
  ShieldCheck,
  Tag,
  Diamond,
  Gem,
  CircleDashed,
  Footprints,
  Gift,
  Star,
  Crown,
  Sun,
};

export function resolveIcon(name) {
  return ICON_MAP[name] || Sparkles;
}
